import React from 'react';
import { NextPageWithLayout } from '~/types/layout';
import { LoginPage } from '~/categories/admin/components/pages/LoginPage';
import { getSingleActionLayout } from '~/components/pages/other/getSingleActionLayout';
import { useAdminPageContext } from '~/categories/admin/hooks/commons/useAdminPageContext';

const Page: NextPageWithLayout = () => {
  const pageContext = useAdminPageContext();
  return <LoginPage {...pageContext} />;
};

Page.Layout = getSingleActionLayout();

Page.config = {
  pageTitle: 'ログイン',
};

export default Page;
